//
//
//
//
//
//
//
//
//

import IconBanner from "@/assets/icons/banner.svg?inline";

export default {
  name: "Banner",
  components: {
    IconBanner,
  },
};
